import styled, { css } from 'styled-components/macro'
import { RadioSize } from '../RadioInput/RadioInput'
import { icons } from '../../../assets/icons'

type InputWrapperProps = {
  error?: boolean | null
  checked?: boolean | null
  size?: RadioSize | null
}

export const CheckInputContainer = styled.div<InputWrapperProps>`
  display: inline-block;
  position: relative;
  cursor: pointer;

  input {
    display: none;
  }

  //input:checked + label span {
  //  background: #2faef3;
  //  border: 2px solid #2faef3;
  //}

  ${(props) =>
    props.checked &&
    css`
      input + label span {
        background-size: ${props.size === 'small' ? '20px 20px' : '25px 25px'};
        border: 2px solid #8cc122 !important;
        background: #8cc122 url('${icons.iconCheckboxInputCheckedV1}') no-repeat center;
      }
    `}

  label {
    margin-bottom: 0;
  }

  input + label span {
    display: inline-block;
    vertical-align: middle;
    width: ${(props) => (props.size && props.size === 'small' ? '20px' : '23x')};
    height: ${(props) => (props.size && props.size === 'small' ? '20px' : '23px')};
    border: 2px solid #626262;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: -2.5px;
  }

  ${(props) =>
    props.error &&
    css`
      input + label span {
        //background: #ff6045 !important;
        border: 2px solid #ff6045 !important;
      }

      span::after {
        content: 'x';
        font-family: CeraProBlack, serif;
        font-style: normal;
        font-size: 14px;
        border: none;
        font-weight: 500;
        color: #ffffff;
        left: 4px;
        top: 2px;
        position: absolute;
        transform: none;
        transition: none;
      }
    `}
`
